import m from "../../geodata/es2015/seychellesLow";
window.am4geodata_seychellesLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/seychellesLow.js
// module id = null
// module chunks = 